import { Button, Modal } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import AuthConfirmOTP from "../authConfirmOTP";
import AuthForgotPassword from "../authForgotPassword";
import AuthSignIn from "../authSignIn";
import AuthSignUp from "../authSignUp";

export const NAME_AUTH = {
  signIn: "SIGN-IN",
  signUp: "SIGN-UP",
  forgotPassword: "FORGOT-PASSWORD",
  confirmOTP: "CONFIRM-OTP",
};

const AuthModal = (props: any) => {
  const { isSignInModal, closeAuthModal } = props;
  const { t } = useTranslation();
  const [nameAuthModal, setNameAuthModal] = React.useState<any>(
    NAME_AUTH.signIn
  );

  const backToSignIn = () => {
    setNameAuthModal(NAME_AUTH.signIn);
  };

  return (
    <Modal
      width={800}
      visible={isSignInModal}
      onCancel={() => {
        setNameAuthModal(NAME_AUTH.signIn);
        closeAuthModal();
      }}
      footer={[
        nameAuthModal !== NAME_AUTH.signIn && (
          <Button
            key="back"
            onClick={backToSignIn}
            style={{
              color: "#0c3b5d",
              borderColor: "#0c3b5d",
            }}>
            {t("title_screen_sign_in")}
          </Button>
        ),
        <Button
          key="submit"
          type="primary"
          onClick={closeAuthModal}
          style={{
            color: "#fff",
            backgroundColor: "#0c3b5d",
            borderColor: "#0c3b5d",
          }}>
          {t("close")}
        </Button>,
      ]}>
      {nameAuthModal === NAME_AUTH.signIn && (
        <AuthSignIn
          {...props}
          type="MODAL"
          closeAuthModal={closeAuthModal}
          setNameAuthModal={setNameAuthModal}
        />
      )}
      {nameAuthModal === NAME_AUTH.signUp && (
        <AuthSignUp
          {...props}
          type="MODAL"
          closeAuthModal={closeAuthModal}
          setNameAuthModal={setNameAuthModal}
        />
      )}
      {nameAuthModal === NAME_AUTH.forgotPassword && (
        <AuthForgotPassword
          {...props}
          type="MODAL"
          closeAuthModal={closeAuthModal}
          setNameAuthModal={setNameAuthModal}
        />
      )}
      {nameAuthModal === NAME_AUTH.confirmOTP && (
        <AuthConfirmOTP
          {...props}
          type="MODAL"
          closeAuthModal={closeAuthModal}
          setNameAuthModal={setNameAuthModal}
        />
      )}
    </Modal>
  );
};

export default AuthModal;
